import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VerticalLabelList from '../../label/VerticalLabelList';
import FieldSet from '../../fieldset/FieldSet';

const EbillingEnrollmentDetail = ({ selectedAccount, }) => {
  const renderAccountData = () => {
    const formattedAccount = Object.keys(selectedAccount)
      .filter(key => !!selectedAccount[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = selectedAccount[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedAccount);
    const exclusions = [ 'Client Data', ];

    return (
      <FieldSet title="Account Data" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  const renderClientData = () => {
    const clientData = selectedAccount.clientData || {};
    const formattedAccount = Object.keys(clientData)
      .filter(key => !!clientData[key])
      .reduce((obj, key) => {
         
        obj[_.startCase(key)] = clientData[key];
        return obj;
      }, {});
    const items = VerticalLabelList.toList(formattedAccount);
    const exclusions = [];

    return (
      <FieldSet title="Client Data" style={{ maxHeight: '400px', }}>
        <VerticalLabelList items={items} exclusions={exclusions} />
      </FieldSet>
    );
  };

  return (
    <>
      {renderAccountData()}
      {renderClientData()}
    </>
  );
};

EbillingEnrollmentDetail.propTypes = {
  selectedAccount: PropTypes.instanceOf(Object).isRequired,
};

export default EbillingEnrollmentDetail;
